import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { FeatureFlag, FeatureFlags, FeatureFlagsLoader } from "@dcc/shared/feature-flags/data-access";
import { toDictionary } from "@dcc/shared/util-data-transformations";
import { Observable, map } from "rxjs";

@Injectable({ providedIn: "root" })
export class FeatureFlagsHttpLoader implements FeatureFlagsLoader {
    private http = inject(HttpClient);

    public getFlags(): Observable<FeatureFlags> {
        return this.http.get<Array<Omit<FeatureFlag, "enabled">>>("api/platform/feature-flags/enabled").pipe(
            map((flags) => {
                const mappedFlags = flags.map((flag) => ({ ...flag, enabled: true }));
                return toDictionary(mappedFlags, "key");
            })
        );
    }
}
